import { Button } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import commonUtils from '@/utils/commonUtils'
import { useDialog } from '@/context/dialogContext'

interface DataRow {
  cmpnyCd: string
  rnum: string
  bizCd: string
  bizNm: string
  useYn: string
  mshipYn: string
  batchYn: string
  rem: string
  manualYn: string
  userName: string
  updDate: string
  chrgeDomain?: string
  newBatchYn: string
  areaCd: string
  addr: string
  latestBaseDt: string
  confidenceLvlCd: string
}

const Component = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`
const More = styled.span`
  font-size: 0.7rem;
  &:hover {
    cursor: pointer;
  }
`
const SubTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  color: #666;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  justify-content: space-between;
`

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`
const NoData = styled.div`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
  font-size: 0.7rem;
  align-items: center;

  & > div {
    text-align: center;
    align-items: center;
  }

  & > div:nth-child(1) {
    flex: 2;
  }
  & > div:nth-child(2),
  & > div:nth-child(3) {
    flex: 3;
  }
  & > div:nth-child(4) {
    flex: 1;
  }
`
const MainPriceCheckList: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const { showAlert, showConfirm } = useDialog()
  const [totalCnt, setTotalCnt] = useState(0)
  const [checkList, setCheckList] = useState<DataRow[]>([])

  useEffect(() => {
    getCheckList()
  }, [])

  const getCheckList = async () => {
    const response = await axios.get('/bizMgmt/checkList', {})
    if (response.status === 200) {
      setCheckList(response.data.data.checkList)
      setTotalCnt(response.data.data.checkList.length)
    } else {
      showAlert({
        type: 'error',
        message: '가격기준일자 목록조회가 실패했어요.',
      })
    }
  }

  return (
    <Component>
      <Title>
        <h4>가격 정보 업데이트 필요 업체</h4>
        <More
          onClick={() => {
            navigate('/bizMgmt')
          }}
        >
          업체관리
        </More>
      </Title>

      {/* 부제목 */}
      <SubTitle>
        <span>
          최근 7일간 가격 데이터 수집이 이루어지지 않은 업체 목록이에요.
        </span>
        <span>총 {totalCnt} 건</span>
      </SubTitle>

      {/* 그리드 */}
      <Grid>
        <Row>
          <div>가격기준일자</div>
          <div>업체코드</div>
          <div>업체명</div>
          <div></div>
        </Row>
        {checkList.length === 0 ? (
          <NoData>체크할 업체가 없어요.</NoData>
        ) : (
          checkList.map((chk: DataRow, index) => (
            <Row key={index}>
              <div>
                {commonUtils.dateStrChgFomat(chk.latestBaseDt, 'yyyy.MM.dd')}
              </div>

              <div
                onClick={() => {
                  navigate('/scrpInfoMgmt', {
                    state: {
                      bizCd: chk.bizCd,
                      bizNm: chk.bizNm,
                    },
                  })
                }}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                {chk.bizCd}
              </div>
              <div>{chk.bizNm}</div>
              <div>
                <Button
                  color="neverbe"
                  variant="texted"
                  size="xs"
                  onClick={() => {
                    navigate('/bizMgmt/priceMgmt', {
                      state: {
                        bizCd: chk.bizCd,
                        bizNm: chk.bizNm,
                      },
                    })
                  }}
                >
                  <span style={{ textDecoration: 'underline' }}>상세</span>
                </Button>
              </div>
            </Row>
          ))
        )}
      </Grid>
    </Component>
  )
}
export default MainPriceCheckList
